/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=0a8e4503"
import script from "./EmptyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=0a8e4503&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports